<template>
  <Dashboard title="Application info">
    <div id="applications">
      <div class="row-small">
        <!-- <div 
          class="col-6 col-12-md"
          v-on:click="handleModal"
          v-if="applications.length !== 0"
        >
          <ApplicationBlock
            to=""
            iconsrc=""
            icontitle="t"
            iconalt=""
            title=""
            subtitle=""
            lang=""
            :addbutton="true"            
          />
        </div> -->

        <div
          v-for="item of applications"
          v-bind:key="item.key"
          class="col-6 col-12-md"
        >
          <ApplicationBlock
            :to="`/applications/${item.id}`"
            :iconsrc="item.icon"
            icontitle="title"
            iconalt="alt"
            :title="item.name"
            :subtitle="item.description"
            :lang="item.language"
            :date="item.liveDate"
          />
        </div>

        <Loading 
          v-if="applications.length === 0"
          full="true"
        />
      </div>
    </div>
    
    <Modal 
      closeIcon="true"
      v-on:close="handleModal"
      v-if="showModal"
    >      
      <template v-slot:title>
        <h3>Add application</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <Input
              class="col-12"
              placeholder="Title"
              type="text"
            />

            <Input
              class="col-12"
              placeholder="Icon"
              type="file"
            />

            <Input
              class="col-12"
              placeholder="Description"
              type="text"
            />

            <Input
              class="col-12"
              placeholder="Language"
              type="text"
            />

            <Input
              class="col-12"
              placeholder="Live date"
              type="date"
            />
          </div>
          
          <Input
            value="Save"
            type="submit"                
          />
        </form>
      </template>      
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../services/api.ts';
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import ApplicationBlock from '../../components/applicationBlock/applicationBlock.vue'
  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import Button from '../../components/buttons/button.vue'
  import Loading from '../../components/loading/loading.vue'

  export default {
    name: 'Applications',
    components: {
      Dashboard,
      ApplicationBlock,
      Modal,
      Input,
      Button,
      Loading
    },
    data() {
      return {
        showModal: false,
        applications: []
      }
    },
    methods: {
      handleModal: function() {
        if (this.showModal === true) {
          this.showModal = false;
        } else {
          this.showModal = true;
        }
      }
    },
    mounted() {
      API.get(
        'index.cfm?act=applications.list&view=all'
      ).then(
        response => (this.applications = response.data.data)
        // response => (console.log(response.data.data))
      )
    }
  }
</script>

<style lang="scss">
  #applications {

  }  
</style>
